module.exports = __webpack_public_path__ + "8f76630c48f4f1f7a92f7d71f86dd741.svg";